import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=9434ff2c&scoped=true&"
import script from "./KPI.vue?vue&type=script&lang=js&"
export * from "./KPI.vue?vue&type=script&lang=js&"
import style0 from "./KPI.vue?vue&type=style&index=0&id=9434ff2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9434ff2c",
  null
  
)

export default component.exports